import { library } from "@fortawesome/fontawesome-svg-core";
import * as Icons from "@fortawesome/free-solid-svg-icons";

import { useMediaQuery } from "@mui/material";
import { useIntersectionObserver, useIsClient } from "@uidotdev/usehooks";
import { FlexContainer, SectionContainer, TextStyled } from "../styles";
import { BenefitsContainer, CardStyled, FontAwesomeIconStyled } from "./styles";

function CompanyBenefits(props) {
  const { companyDetail, setCurrentTab } = props || {};
  const isDesktop = useMediaQuery("(min-width: 1280px)");

  const [ref, entry] = useIntersectionObserver();
  entry?.isIntersecting ? setCurrentTab(4) : null;

  const isClient = useIsClient();

  const iconList = Object.keys(Icons)
    .filter((key) => key !== "fas" && key !== "prefix")
    .map((icon) => Icons[icon]);

  library.add(...iconList);

  const replaceIcon = (iconCode) => {
    if (iconCode === "money") {
      iconCode = "money-bill-alt";
    } else if (iconCode === "clock-o") {
      iconCode = "clock";
    }
    return iconCode;
  };

  return (
    <SectionContainer
      aria-label="company benefits section"
      id="CompanyBenefits"
      ref={ref}
    >
      <TextStyled
        variant="h2"
        fontSize="1.25rem"
        fontWeight={700}
        textTransform="capitalize"
        aria-label="company benefits section title"
        color={"#000"}
      >
        Company Benefits
      </TextStyled>
      <BenefitsContainer>
        {companyDetail.map((benefit, index) => {
          return (
            <CardStyled key={index} id="cdp-benefit">
              <FlexContainer
                flexDirection={isDesktop ? "row" : "column"}
                gap={"1rem"}
                maxWidth={"100%"}
                width={"100%"}
              >
                {isClient && (benefit.iconCode || benefit.icon_code) ? (
                  <FontAwesomeIconStyled
                    alt={
                      replaceIcon(benefit.iconCode || benefit.icon_code) +
                      " icon"
                    }
                    icon={replaceIcon(benefit.iconCode || benefit.icon_code)}
                    style={{
                      maxWidth: isDesktop ? "56px" : "40px",
                      minWidth: isDesktop ? "56px" : "40px",
                      width: isDesktop ? "56px" : "40px",
                    }}
                  />
                ) : null}
                <FlexContainer
                  flexDirection={"column"}
                  gap={"1rem"}
                  overflow={"hidden"}
                  sx={{ overflowWrap: "anywhere" }}
                >
                  <TextStyled
                    variant="h3"
                    fontSize="1rem"
                    fontWeight={700}
                    letterSpacing="0.00625rem"
                  >
                    {benefit?.title}
                  </TextStyled>
                  <TextStyled
                    variant="body1"
                    fontSize="0.875rem"
                    fontWeight={400}
                    letterSpacing="0.15px"
                  >
                    {benefit?.description}
                  </TextStyled>
                </FlexContainer>
              </FlexContainer>
            </CardStyled>
          );
        })}
      </BenefitsContainer>
    </SectionContainer>
  );
}

export default CompanyBenefits;
